module.exports = __webpack_public_path__ + "img/architecture.30558052.png";